import React from "react";

import { useEffect, useRef } from 'react';

function Canvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const $ = canvas.getContext('2d');
    let h = canvas.height = window.innerHeight;
    let w = canvas.width = window.innerWidth;

    const random = (n) => Math.random() * n;
    const stars = new Array(1000).fill().map(() => {
      return { r: random(w), s: random(0.008), a: random(Math.PI * 2) };
    });

    function loop() {
      $.fillStyle = 'rgba(0,0,0,.9)';
      $.fillRect(0, 0, w, h);
      stars.forEach((e) => {
        e.a += e.s;
        $.save();
        $.beginPath();
        $.translate(w / 2, h / 2);
        $.rotate(e.a);
        $.arc(e.r, e.r, 1, 0, Math.PI * 2);
        //$.arc(Math.cos(e.a)*e.r + w/2, Math.sin(e.a)*e.r + h/2,1,0,Math.PI*2);
        $.closePath();
        $.fillStyle = 'white';
        $.fill();
        $.restore();
      });
      requestAnimationFrame(loop);
    }
    loop();

    function handleResize() {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    }
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return <canvas ref={canvasRef} style={{ position: 'absolute', top: 0, left: 0 , zIndex: -1 , overflow: 'hidden', minHeight: '100vh', width: '100%'}} />;
}

export default Canvas;
 
